// Lib
import React, { useEffect, useMemo } from 'react';

// Utils
import randomString from '../../../common/uid/randomString';

// Hooks
import { useToastContext } from './ToastContext';

// Styles
import './Toast.scss';

interface ToastProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    className?: string;
    /** Optional parent identifier for parent-aware positioning */
    groupId?: string;
}

const Toast: React.FC<ToastProps> = ({ className, children, groupId, ...props }) => {
    const toastId = useMemo(() => {
        const randStr = randomString(6);
        if (className) return `${className}-${randStr}`;
        return randStr;
    }, []);

    const { addToast, removeToast } = useToastContext();

    const toastData = useMemo(
        () => ({
            id: toastId,
            groupId,
            children,
            className,
            props,
        }),
        [toastId, groupId, children, className, props],
    );

    useEffect(() => {
        addToast(toastData);
    }, [addToast, toastData]);

    useEffect(
        () => () => {
            removeToast(toastId);
        },
        [removeToast, toastId],
    );

    return null;
};

export default Toast;
